import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import './radio-button-group.scss';
import { RadioButton } from '../Buttons/RadioButton/radio-button';
function RadioButtonGroup({ title, values, onChange, chosenValue, hasError, hideTitle }) {
    const radioButtons = values.map(value => (_jsx(RadioButton, { name: title, onClick: onChange, checked: chosenValue === value, label: value, value: value }, value)));
    const label = hasError ? `* ${title}` : title;
    const className = hasError ? 'radio-group--error' : 'radio-group';
    return (_jsxs("div", { className: className, children: [!hideTitle && _jsx("label", { className: "radio-group-label", children: label }), _jsx("div", { className: "radio-buttons", children: radioButtons })] }));
}
RadioButtonGroup.propTypes = {
    values: PropTypes.arrayOf(PropTypes.string).isRequired,
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    chosenValue: PropTypes.string,
    hasError: PropTypes.bool,
    hideTitle: PropTypes.bool,
};
RadioButtonGroup.defaultProps = {
    chosenValue: '',
    hasError: false,
};
export default RadioButtonGroup;
